import { Component, Inject, inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";

@Component({
  selector: 'app-default-setting-dialog',
  templateUrl: './default-setting-dialog.component.html',
  styleUrls: ['./default-setting-dialog.component.scss']
})
export class DefaultSettingDialogComponent {
  private dialogRef: MatDialogRef<DefaultSettingDialogComponent> = inject(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  public weightDefault: boolean = true;
  public heightDefault: boolean = true;

  public onConfirm(): void {
    if (this.data.isWeightChanged && this.data.isHeightChanged) {
      this.dialogRef.close({
        weight: this.weightDefault,
        height: this.heightDefault,
      });
    } else if (this.data.isWeightChanged && !this.data.isHeightChanged) {
      this.dialogRef.close({
        weight: this.weightDefault,
        height: null,
      });
    } else if (!this.data.isWeightChanged && this.data.isHeightChanged) {
      this.dialogRef.close({
        weight: null,
        height: this.heightDefault,
      });
    }
  }

  public onDismiss(): void {
    this.dialogRef.close(false);
  }
}
